export const refreshToken = next => {
  // await store.dispatch('user/refreshToken');
  // await sleep(10000);
  return next();
};
